import React from "react";
import ReactDOM from "react-dom";
import AuthorizationRelationControl, { IProps } from "../../common/controls/AuthorizationRelationControl";
import { IConfig, IFieldsConfig } from "../../common/controls/RelationAuthorizations/Models";
import { stringToIssue } from "../../common/controls/Relations/IssueForRelations";
import { WorkflowContext } from "../ajaxWorkflowModal/WorkflowContext";

function stringToObject(value: string) {
	if (!value)
		return undefined;

	return JSON.parse(value);
}

export default function (control: HTMLDivElement, i: number) {

	var config = JSON.parse(control.dataset.config) as IConfig;
	var defaults: IFieldsConfig = {
		employee: {
			hidden: false,
			multiple: false,
			maxRows: 20,
		},
		dataSet: {
			hidden: false,
			multiple: false,
			maxRows: 20,
		},
		businessProcess: {
			hidden: true,
			multiple: false,
			maxRows: 20,
		},
		dateFrom: {
			columnHidden: false,
			hidden: false,
			required: false,
		},
		dateTo: {
			columnHidden: false,
			hidden: false,
			required: false,
		},
		level: {
			columnHidden: false,
			hidden: false,
			required: false,
		},
	}
	for (var p in defaults) {
		if (!config.fields[p])
			config.fields[p] = defaults[p];
	}

	return ReactDOM.createPortal(
		<WorkflowAuthorizationResourceRelationsData
			key={"react-authorization-resource-relations-data-" + i}
			issue={stringToIssue(control.dataset.issue)}

			name={control.dataset.name}
			value={control.dataset.value}
			isValidField={control.dataset.isValidField === "True"}

			defaultEmployee={control.dataset.defaultEmployee}

			editCurrentEmployee={control.dataset.editCurrentEmployee === "True"}

			blockInsert={control.dataset.blockInsert === "True"}
			blockEditRows={control.dataset.blockEditRows === "True"}
			blockCloneRows={control.dataset.blockCloneRows === "True"}
			blockDeleteRows={control.dataset.blockDeleteRows === "True"}

			forAcceptant={control.dataset.forAcceptant === "True"}
			subordinatesTree={control.dataset.subordinatesTree === "True"}
			blockChangeEmployees={control.dataset.blockChangeEmployees === "True"}

			currentAuthorizationsHiddenInsertButton={control.dataset.currentAuthorizationsHiddenInsertButton === "True"}
			currentAuthorizationsHiddenEditButton={control.dataset.currentAuthorizationsHiddenEditButton === "True"}
			currentAuthorizationsFilterId={control.dataset.currentAuthorizationsFilterId}
			currentAuthorizationsTable={stringToObject(control.dataset.currentAuthorizationsTable)}

			config={config}
		/>,
		control);
};

export function WorkflowAuthorizationResourceRelationsData(props: IProps) {
	return <WorkflowContext.Consumer>
		{({ issueWorkflowData, setIssueWorkflowData }) => (
			<AuthorizationRelationControl {...props} onSet={(value) => {
				let data = { ...issueWorkflowData };
				data[props.name] = value;
				setIssueWorkflowData(data);
			}} />
		)}
	</WorkflowContext.Consumer>
}